import {useEffect, useState} from 'react';
import {UsersFilter} from '../types';

// Module-scoped filter store (docs/patterns/global-filter-store-pattern.md): the
// Filter button with its badge, the drawer and the list hook must observe ONE
// filter, and they live in different components. Do not replace it with a local
// useState (FNP-815).
let globalFilters: UsersFilter = {};
const filterListeners: Set<(filters: UsersFilter) => void> = new Set();

const notifyFilterChange = (filters: UsersFilter) => {
    globalFilters = filters;
    filterListeners.forEach(listener => listener(filters));
};

export const useUsersFilter = () => {
    const [filters, setFilters] = useState<UsersFilter>(globalFilters);

    useEffect(() => {
        const listener = (newFilters: UsersFilter) => setFilters(newFilters);
        filterListeners.add(listener);
        // A consumer mounting after the filter was set must not start from {}.
        setFilters(globalFilters);
        return () => {
            filterListeners.delete(listener);
        };
    }, []);

    const handleSetFilters = (newFilters: UsersFilter) => {
        const clean = Object.entries(newFilters)
            .reduce((acc: Record<string, string>, [key, value]) => {
                if (typeof value === 'string' && value.trim() !== '') {
                    acc[key] = value.trim();
                }
                return acc;
            }, {});
        notifyFilterChange(clean);
    };

    const handleClearFilters = () => notifyFilterChange({});

    return {
        filters,
        activeCount: Object.keys(filters).length,
        handleSetFilters,
        handleClearFilters,
    };
};
